import './Project.css'
import { Link } from 'react-router-dom'

const Project = ({id, name, images}) => {
    return(
        <article className='card'>
            <Link to={`/project/${id}`}>
                <picture>
                    <img src={images[0]} alt={name} className='card-img'/>
                </picture>
                <section>
                    <p className='card-title'>{name}</p>
                </section>
            </Link>
        </article>
    )
}

export default Project